import { initWebinarsHub } from '../../snippets/webinar-hub-page/webinar-hub-page';
import { WEBINAR_TYPES } from '../../scripts/config/constants';

initWebinarsHub(WEBINAR_TYPES.PRO_INSTALLERS);
